export const bookHorse = (bookingDetails) => ({
  type: "BOOK_HORSE",
  payload: bookingDetails,
});